export function hexToRgba(hexColor: string | undefined, opacity = 100) {
  if (!hexColor) {
    return 'rgba(0,0,0,0)';
  }

  const normalized = hexColor.replace('#', '');
  const value =
    normalized.length === 3
      ? normalized
          .split('')
          .map((part) => `${part}${part}`)
          .join('')
      : normalized;

  const red = parseInt(value.slice(0, 2), 16);
  const green = parseInt(value.slice(2, 4), 16);
  const blue = parseInt(value.slice(4, 6), 16);

  return `rgba(${red},${green},${blue},${opacity / 100})`;
}
